import { useTokenSearch } from '@/hooks/useTokenSearch';
import type { ViewHistoryItem } from '@/types/view';
import { useRouter } from 'next/navigation';
import { TimeAgo } from './TimeAgo';

function truncateAddress(addr: string): string {
  return addr.length > 12 ? `${addr.slice(0, 6)}...${addr.slice(-4)}` : addr;
}

function tierLabel(tier: number): string {
  switch (tier) {
    case 0:
      return 'Free';
    case 1:
      return 'Plus';
    case 2:
      return 'Premium';
    case 3:
      return 'Diamond';
    default:
      return 'Unknown';
  }
}

function tierColor(tier: number): string {
  switch (tier) {
    case 0:
      return 'badge-neutral';
    case 1:
      return 'badge-info';
    case 2:
      return 'badge-success';
    case 3:
      return 'badge-warning';
    default:
      return 'badge-ghost';
  }
}

interface RecentSearchItemProps {
  item: ViewHistoryItem;
  onInvalidate?: () => void;
}

export function RecentSearchItem({ item, onInvalidate }: RecentSearchItemProps) {
  const router = useRouter();
  const { handleSearch, invalidateTokenQueries } = useTokenSearch();
  return (
    <li
      className="flex items-center justify-between px-2 py-2 rounded hover:bg-gray-800 transition cursor-pointer"
      onClick={async e => {
        e.preventDefault();
        invalidateTokenQueries(item.token_address);
        await handleSearch(item.token_address);
        if (onInvalidate) onInvalidate();
        router.push(`/ca/${item.token_address}`);
      }}
    >
      <div className="flex flex-col">
        <span className="font-mono text-sm text-primary-content">
          {truncateAddress(item.token_address)}
        </span>
        <TimeAgo dateString={item.created_at} />
      </div>
      <span className={`badge ${tierColor(item.tier)} text-xs`}>{tierLabel(item.tier)}</span>
    </li>
  );
}
